import { useCurrency } from "@/context/CurrencyContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function CurrencySelect({ className = "w-[110px]" }) {
  const { config, currency, setCurrency } = useCurrency() || {};
  if (!config) return null;
  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger className={className} data-testid="currency-select"><SelectValue /></SelectTrigger>
      <SelectContent>
        {(config.currencies || []).map((c) => (
          <SelectItem key={c.code} value={c.code} data-testid={`currency-${c.code}`}>{c.code}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
